<template>
  <base-modal-component
    :header="false"
    height="300px"
    width="360px"
    :zindex="3"
    @close="
      $emit('close');
      $emit('update');
    "
  >
    <template #body>
      <div class="text-center text-lg h-full flex flex-col justify-center">
        <div class="whitespace-pre-wrap">{{ alertMsg() }}</div>
      </div>
    </template>
    <template #footer>
      <button
        @click="
          $emit('close');
          $emit('update');
        "
        class="h-12 w-full"
      >
        확인
      </button>
    </template>
  </base-modal-component>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlertStore } from '@/stores/alert';

import BaseModalComponent from '@/components/baseComponent/BaseModal.vue';

export const alertModalControl = () => {
  const alertStore = useAlertStore();

  const alertModalClose = () => {
    alertStore.updateErrorMsg('');
    alertStore.openAlert(null);
  };

  const isOpenAlertModalCode = computed(() => alertStore.code);
  const propsAlertModalMsg = computed(() => alertStore.errorMsg);
  return {
    alertModalClose,
    isOpenAlertModalCode,
    propsAlertModalMsg,
  };
};

export default defineComponent({
  name: 'ModalAlert',
  components: { BaseModalComponent },
  props: {
    code: { type: String as PropType<any>, required: true },
    message: { type: String, default: '' },
  },
  setup: (props) => {
    const { t } = useI18n();
    const { code, message } = toRefs(props);
    const alertMsg = () => {
      switch (code.value) {
        case 400:
          return t('alert.400');
        case 401:
          return t('alert.401');
        case 403:
          return t('alert.403');
        case 404:
          return t('alert.404');
        case 500:
          return t('alert.500');
        case 12005:
          return '유효하지않은 카드번호를 입력하셨습니다. (card_bin 없음)'; //추후 에러관리 백엔드랑 협의 (임시용))
        default:
          return message.value ? message.value : t('alert.default');
      }
    };

    return {
      alertMsg,
    };
  },
});
</script>

<style lang="scss" scoped></style>
